import React from "react";
import { useIsMobile } from "./Flexbox";

const HIDE_SCROLLBAR = 'filter-bar-no-scrollbar';

const FilterBar = props => {
    const isMobile = useIsMobile();

    const mobileScrollStyle = {
        flexWrap: 'nowrap',
        overflowX: 'auto',
        overflowY: 'hidden',
        justifyContent: 'flex-start',
        height: 'auto',
        minHeight: 'fit-content'
    };

    return (
        <div className={[props.className, isMobile ? HIDE_SCROLLBAR : ''].filter(Boolean).join(' ')}
            style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingRight: '16px', ...props.style, ...(isMobile ? mobileScrollStyle : {})}}>
            <style>
                {`.${HIDE_SCROLLBAR}::-webkit-scrollbar { display: none; }`}
            </style>
            {React.Children.map(props.children, child => (
                isMobile ? <div style={{display: 'flex', flexShrink: 0}}>{child}</div> : child
            ))}
        </div>
    )
}

export default FilterBar;
